//#region Imports
import { Helper } from '@rawlings/core';
import { Injectable } from '@angular/core';
import { LoginResultDto } from '../model/loginResultDto';
import { SessionStorageService } from './session-storage.service';
import { SurveyResponseDto } from '../model/surveyResponseDto';
import { SurveySummaryDto } from '../model/surveySummaryDto';
//#endregion Imports
@Injectable({
  providedIn: 'root'
})
export class SharedMemberResponseService {
    //#region Constructor
    constructor(private sessionStorageService: SessionStorageService){
        this.queueLetterId = sessionStorageService.GetQueueLetterId();
        this.referenceNumber = sessionStorageService.GetReferenceNumber();
        this.surveyResponse = sessionStorageService.GetSurveyResponse() || new SurveyResponseDto();
        this.activeSurveyStepIndex = sessionStorageService.GetActiveSurveyStepIndex();
        this.surveySummary = sessionStorageService.GetSurveysummary() || new SurveySummaryDto();
    }
    //#endregion Constructor

    //#region Private properties
    private queueLetterId:number = null;
    private referenceNumber: string = null;
    private surveyResponse: SurveyResponseDto = null;
    private activeSurveyStepIndex: number = null;
    private surveySummary: SurveySummaryDto = null;
    //#endregion Private properties

    //#region Public properties
    public SetQueueLetterData(id: number, referenceNumber : string) : void {
        this.SetQueueLetterId(id);
        this.SetReferenceNumber(referenceNumber);
    }

    public SetQueueLetterId(id: number) : void {
        this.queueLetterId = id;
        this.sessionStorageService.SaveQueueLetterId(id);
    }

    public SetSurveyResponseId(id :number) : void {
        if(Helper.IsEmpty(this.surveyResponse)){
            this.surveyResponse = new SurveyResponseDto();
        }
        this.surveyResponse.SurveyResponseId = id;
        this.sessionStorageService.SaveSurveyResponse(this.surveyResponse);
    }

    public SetReferenceNumber(referenceNumber : string) : void {
        this.referenceNumber = referenceNumber;
        this.sessionStorageService.SaveReferenceNumber(referenceNumber);
    }

    public SetSurveyResponse(surveyResponse :SurveyResponseDto) : void{
        this.SetSurveyResponseId(surveyResponse.SurveyResponseId);
        this.surveyResponse = surveyResponse;
        this.sessionStorageService.SaveSurveyResponse(surveyResponse);
    }

    public GetQueueLetterId() : number {
        return this.queueLetterId;
    }

    public GetSurveyResponseId() : number {
        return this.surveyResponse?.SurveyResponseId;
    }

    public GetReferenceNumber() : string {
        return this.referenceNumber;
    }

    public GetSurveyResponse() : SurveyResponseDto {
        return this.surveyResponse;
    }

    public DeleteSession() : void {
        this.queueLetterId = null;
        this.surveyResponse = null;
        this.referenceNumber = null;
        this.activeSurveyStepIndex = null;
        this.surveySummary = null;
        this.sessionStorageService.DeleteSession();
    }

    public GetActiveSurveyStepIndex(): number{
        return this.activeSurveyStepIndex ?? 0;
    }

    public SetActiveSurveyStepIndex(index : number): void{
        this.activeSurveyStepIndex = index;
        this.sessionStorageService.SaveActiveSurveyStepIndex(index);
    }

    public SetSurveySummary(surveySummary: SurveySummaryDto): void {
        this.surveySummary = surveySummary || new SurveySummaryDto();
        this.sessionStorageService.SaveSurveySummary(surveySummary);
    }

    public SetSurveyData(data: LoginResultDto): void {
        if(!Helper.IsEmpty(data?.SurveyResponse)){
            this.SetSurveyResponse(data.SurveyResponse);
        }
        this.SetSurveySummary(data?.SurveySummary);
    }

    public GetSurveySummary(): SurveySummaryDto{
        return this.surveySummary;
    }

    public GetSurveySummarySection(formName: keyof SurveySummaryDto): Partial<SurveySummaryDto[keyof SurveySummaryDto]>{
        if(Helper.IsEmpty(this.surveySummary)){
            return null;
        }
        return this.surveySummary[formName];
    }

    public UpdateSurveySummary(formName: keyof SurveySummaryDto, newData: Partial<SurveySummaryDto[keyof SurveySummaryDto]>): void{
        const currentData: any = this.surveySummary && this.surveySummary[formName] ? this.surveySummary[formName] : {};
        this.surveySummary[formName] = {
            ...currentData,
            ...newData,
        };
        this.sessionStorageService.SaveSurveySummary(this.surveySummary);
    }
    //#endregion Public properties
}
